import { useToastStore } from "../store/toast";

type PersistentToastOptions = {
  title?: string;
  description?: string;
  content: React.ReactNode;
  minimiseOnDismiss?: boolean;
  onClose?: () => void;
};

export const useToast = () => {
  const { showToast, closeToast, toggleExpand } = useToastStore();

  // Simplified implementation for toast with smart type detection
  const persistentToast = (
    contentOrOptions: React.ReactNode | PersistentToastOptions
  ) => {
    if (!contentOrOptions) return; // Guard against null or undefined

    // Determine if it's options object with content
    const isOptionsObject =
      typeof contentOrOptions === "object" &&
      contentOrOptions !== null &&
      "content" in contentOrOptions;

    // Process toast parameters
    if (isOptionsObject) {
      const options = contentOrOptions as PersistentToastOptions;
      showToast({
        title: options.title,
        description: options.description,
        content: options.content,
        id: Date.now().toString(),
        minimiseOnDismiss: options.minimiseOnDismiss,
        onClose: options.onClose,
      });
    } else {
      // Direct content passed
      showToast({
        content: contentOrOptions as React.ReactNode,
        id: Date.now().toString(),
      });
    }
  };

  const dismissToast = (callback?: () => void) => {
    closeToast(); // Use closeToast to fully remove the toast

    // Execute the callback function if provided
    if (callback && typeof callback === "function") {
      callback();
    }
  };

  const toggleToastExpand = () => {
    toggleExpand();
  };

  return {
    persistentToast,
    dismissToast,
    toggleToastExpand,
  };
};
